import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "core-gang-master",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./coreGangMaster.html",
})
export class coreGangMaster implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  groupbyList = ["DESIGN NO", "SHADE"];
  filter = {
    statustype: "",
    statusArray: [],
    type: "All",
  };
  typeList = ["All", "Core", "Gang"];
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "status,core_designno",
    orderDir: "desc",
  };
  printConfig: any = {
    title: "Core Design Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  exceldata: any;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editTemplate") editTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  statusList = ["ACTIVE", "INACTIVE"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  party_design: string;
  core_design: string;
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    debugger;
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Party Design",
        prop: "pdesign_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Party Shade",
        prop: "pshade",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Core Design",
        prop: "core_designno",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Shade",
        prop: "shade",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Status",
        prop: "status",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Action",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.editTemplate,
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    this.filterPanel.close();
    if (this.filter.statusArray.length == 1) {
      this.filter.statustype = this.filter.statusArray[0];
    } else {
      this.filter.statustype = "";
    }
    this.getOrderList();
  }

  onClickSale(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["statustype"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  addCoreGang(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD CORE-GANG DESIGN",
          title: "ADD CORE-GANG DESIGN",
          tabParent: "PURCHASE REPORTS",
          mode: mode,
          data: row,
          name: "ADD CORE-GANG DESIGN",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "EDIT CORE-GANG DESIGN",
          title: "EDIT CORE-GANG DESIGN",
          tabParent: "PURCHASE REPORTS",
          mode: mode,
          data: row,
          name: "EDIT CORE-GANG DESIGN",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getOrderList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      menu: this.menu.param,
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getCoreDesignReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        // if(that.filter.groupby == 'SHADE'){
        //     res.columns.push({ name: 'Action', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: that.editTemplate });
        // }

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Core Design Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onCellClick($event) {
    this.filter["design_no"] = $event.row.pdesign_no;
    this.party_design = $event.row.pdesign_no;
    this.core_design = $event.row.core_designno;
    this.getOrderList();
  }
  onbackbutton() {
    this.filter["design_no"] = "";
    this.getOrderList();
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/coreGangMaster/coreGangMaster.ts